export default __webpack_public_path__ + "static/card-0077fc4a97aed594afeaf3e4accbec9c.jpg";